import { types } from "../actions";

const initialState = {
  bannerInfo: {
    showNotification: false,
    type: '',
    priority: '',
    isDismissible: true,
  },
};

const notificationBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_NOTIFICATION_BANNER: {
      const isNonDismissibleBanner =
        state.bannerInfo.showNotification &&
        state.bannerInfo.isDismissible === false &&
        action.bannerInfo.showNotification;

      if (isNonDismissibleBanner) {
        return state;
      }
      return {
        ...state,
        bannerInfo: {
          ...initialState.bannerInfo,
          ...action.bannerInfo
        }
      };
    }
    
    default:
      return state;
  }
};
export default notificationBannerReducer;